import { authenticatedAxios } from "../utils/apiService";

export const loadAllGradingList = async (
  setList,
  setOtherDetails,
  showAlert
) => {
  try {
    const res = await authenticatedAxios.get("/v1/clinic/grading/list");
    const { embryos, oocytes, otherDetails } = res.data.data;
    const { eggGradingUrl, embryoGradingUrl } = otherDetails;
    setOtherDetails({
      eggGradingUrl: {
        value: eggGradingUrl,
        error: "",
      },
      embryoGradingUrl: {
        value: embryoGradingUrl,
        error: "",
      },
    });

    setList({ embryos, oocytes });
  } catch (error) {
    showAlert(
      error?.response?.data?.message || "Something went wrong.",
      "error"
    );
  }
};
